import {
  SweepCanvasSelectionMode,
  useCanvasControlsCtx,
} from '../../../../sweep-canvas/canvas-controls/CanvasControlsCtx';
import { CurserDrag, Cursor } from '@sweep-io/sweep-design/dist/icons';
import { CanvasToolbarButton } from './CanvasToolbarButton';
import { colors } from '@sweep-io/sweep-design';
import { styled } from '@mui/material/styles';
import { useKeyboardSelectionMode } from '../../../../sweep-canvas/hooks/useKeyboardSelectionMode';
import { ExclusiveButtonId, useCanvasToolbarContext } from './CanvasToolbarCtx';
import { useCallback } from 'react';

const KeySpan = styled('span')({
  marginLeft: '12px',
  color: colors.grey[500],
});

const allowedExclusiveButtons: ExclusiveButtonId[] = [
  'metadataElements',
  'templatesAndPlugins',
  'addFunnelMenu',
  null,
];

export const CanvasSelectionModeButtons = ({ isDisabled }: { isDisabled?: boolean }) => {
  const { setSelectionMode: setMode, selectionMode: mode } = useCanvasControlsCtx();
  const { activeExclusiveButton, setActiveExclusiveButton } = useCanvasToolbarContext();

  const isAllowedToBePressed = allowedExclusiveButtons.includes(activeExclusiveButton);

  const { selectionMode } = useKeyboardSelectionMode({
    selectionMode: mode,
    setSelectionMode: setMode,
    disableMultiSelection: false,
  });

  const setModeAndExclusiveButton = useCallback(
    (newMode: SweepCanvasSelectionMode) => () => {
      setMode(newMode);
      if (activeExclusiveButton && !allowedExclusiveButtons.includes(activeExclusiveButton)) {
        setActiveExclusiveButton(null);
      }
    },
    [activeExclusiveButton, setActiveExclusiveButton, setMode],
  );

  return (
    <>
      <CanvasToolbarButton
        tooltip={
          <>
            Select<KeySpan>V</KeySpan>
          </>
        }
        onToggle={setModeAndExclusiveButton(SweepCanvasSelectionMode.selectOnDrag)}
        pressed={selectionMode === SweepCanvasSelectionMode.selectOnDrag && isAllowedToBePressed}
        disabled={isDisabled}
      >
        <Cursor />
      </CanvasToolbarButton>
      <CanvasToolbarButton
        tooltip={
          <>
            Hand<KeySpan>H</KeySpan>
          </>
        }
        onToggle={setModeAndExclusiveButton(SweepCanvasSelectionMode.panOnDrag)}
        pressed={selectionMode === SweepCanvasSelectionMode.panOnDrag && isAllowedToBePressed}
        disabled={isDisabled}
      >
        <CurserDrag />
      </CanvasToolbarButton>
    </>
  );
};
